export default {
    namespaced: true,
    state: {
        pageTemplatesContentIds: {},
        pageTemplatesContentAreas: undefined
    },
    mutations: {
        pageTemplatesContentIds(state, {templateId, contentIds}) {
            state.pageTemplatesContentIds[templateId] = contentIds
        },
        pageTemplatesContentAreas(state, pageTemplatesContentAreas) {
            state.pageTemplatesContentAreas = pageTemplatesContentAreas
        }
    },
    getters: {
        contentAreas: (state, getters, rootState) => (templateHtml) => {
            let contentAreas = []
            
            if (templateHtml) {
                let extendsMatch = templateHtml.match(/\{% extends '(.*)' %}/)
                
                if (extendsMatch) {
                    const title = extendsMatch[1]
                    const item = rootState.templates.items.find(o => o.title === title)
                    
                    if (item) {
                        let parentHtml = item.templateHtml
                        
                        // 1. Improved regex to capture blocks more reliably
                        const blockRegex = /\{% block\s+([^\s%]+)\s%}(.*?){% endblock(?:\s+\1)?\s%}/gs;
                        const blockMatches = [...templateHtml.matchAll(blockRegex)];
                        
                        for (const match of blockMatches) {
                            const blockName = match[1];
                            const replaceContent = match[2];
                            
                            // 2. Flexible replacement regex for the parent HTML
                            // Matches {% block name %}, content, and {% endblock %} or {% endblock name %}
                            const parentBlockRegex = new RegExp(
                                '\\{% block\\s+' + blockName + '\\s%\\}(.*?)\\{% endblock(?:\\s+' + blockName + ')?\\s%\\}',
                                'gs'
                            );
                            
                            parentHtml = parentHtml.replace(parentBlockRegex, replaceContent);
                        }
                        
                        templateHtml = parentHtml;
                    }
                }
                
                // 3. Extract content areas
                // Combined regex to look for both area_content('name') and content['name']
                const areaRegex = /(?:area_content\(|content\[)['"]([^'"]+)['"]/g;
                let areaMatch;
                
                while ((areaMatch = areaRegex.exec(templateHtml)) !== null) {
                    // areaMatch[1] is the first capturing group (the name inside quotes)
                    if (!contentAreas.includes(areaMatch[1])) {
                        contentAreas.push(areaMatch[1]);
                    }
                }
            }
            
            return contentAreas;
        },
        contentIds: () => (templateHtml) => {
            let contentIds = []
            
            if (templateHtml) {
                const matches = [...templateHtml.matchAll(/content\(([0-9]+)\)/g)]
                if (matches) {
                    matches.forEach((match) => {
                        contentIds.push(parseInt(match[1]))
                    })
                }
            }
            
            return contentIds
        },
    },
    actions: {
        async init({state, dispatch, rootGetters, getters, commit}) {
            if (state.pageTemplatesContentAreas === undefined) {
                await dispatch('templates/init', false, {root: true})
                
                const areas = {}
                rootGetters['templates/pageTemplates'].forEach((o) => {
                    areas[o.id] = getters['contentAreas'](o.templateHtml)
                })
                
                commit('pageTemplatesContentAreas', areas)
            }
        },
        async getPagesContentAreas({dispatch, rootState, getters}, pageId) {
            const page = await dispatch('itemData/get', {
                tableName: 'pages',
                id: pageId,
            }, {root: true})
            const templateId = page.templateId
            
            const template = await dispatch('itemData/get', {
                tableName: 'templates_templates',
                id: templateId,
            }, {root: true})
            
            return getters['contentAreas'](template.templateHtml)
        },
        async getPageTemplatesContentIds({state, dispatch, rootState, commit}, templateId) {
            // New page forms don't have a templateId
            if (templateId) {
                let contentIds = state.pageTemplatesContentIds[templateId]
                if (contentIds) {
                    return contentIds
                }
                
                contentIds = (await dispatch('request/get', {
                    url: rootState.websiteEndpoint + '/controller/page_template_content_ids/' + templateId
                }, {root: true}))?.data.contentIds
                
                commit('pageTemplatesContentIds', {templateId, contentIds})
                
                return contentIds
            }
        }
    }
}